module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"retrieve-password":"重置密码","tips":"温馨提示","text":"由于您没有进行过账号绑定，无法自行重置密码如需重置密码，请联系客服。","contact-us":"联系客服","document-title":"重置密码"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
